import { form } from '../../formState'

import { usePhoneValidation } from './hooks/usePhoneValidation'
import { useTexts } from './hooks/useTexts'

export function PhoneField() {
  const texts = useTexts()
  const validatePhone = usePhoneValidation()
  const backOfficePhone = form.useFormField('backOfficePhone')
  const status = form.useFormField('status')
  const callbackConfigStatus = form.useFormField('callbackConfigStatus')

  const helperText =
    backOfficePhone.field.status === 'invalid'
      ? texts.backOfficePhone.hint
      : texts.backOfficePhone.caption

  form.useAddFieldValidation<'backOfficePhone'>(
    'backOfficePhone',
    async (field, _formApi) => {
      const phoneValidation = await validatePhone(
        field.value,
        status.field.value,
        callbackConfigStatus.field.value,
      )

      return (
        phoneValidation.phoneNumberRequiredError?.message ||
        phoneValidation.phoneNumberValidError?.message
      )
    },
    { customUID: 'backOfficePhone' },
  )

  return (
    <form.TextField
      testId="voice-back-office-phone"
      name="backOfficePhone"
      label={texts.backOfficePhone.label}
      validateOn="blur change"
      helperText={helperText}
    />
  )
}
